import React from "react";
import { Row, Col } from "reactstrap";
import { Breadcrumbs, TokenAppenditure } from "../Utility/common";
import { Capacitor } from "@capacitor/core";
import { isMobile } from "react-device-detect";
import { Inbox } from "@talkjs/react";

const ChatPage = () => {
  // Calculate the appropriate height based on platform
  const getContainerHeight = () => {
    if (Capacitor.isNativePlatform() || isMobile) {
      return "calc(100vh - 120px)"; // Taller for mobile devices
    }
    return "calc(100vh - 160px)"; // Slightly shorter for desktop to account for header
  };

  return (
    <React.Fragment>
      <div
        className={`page-content ${!Capacitor.isNativePlatform() && !isMobile && "pt-2"}`}
        style={{
          height: "90vh",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <div
          className="container"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0 // Prevents flex container from overflowing
          }}
        >

          {!Capacitor.isNativePlatform() &&
            Breadcrumbs(
              "Chat",
              "Home",
              `/dashboard${TokenAppenditure()}`
            )
          }
          {!Capacitor.isNativePlatform() && (
            <h4 className="madeGentle mb-0">Chat</h4>

          )}
          <Row className="flex-grow-1">
            <Col className="col-12">
              <div
                className="chat-container bg-white rounded shadow-sm h-100 mb-5"
                style={{
                  height: getContainerHeight(),
                  marginTop: Capacitor.isNativePlatform() || isMobile ? "0px" : "1rem",
                  marginBottom:'1rem',
                  overflow: "hidden"
                }}
              >
                <Inbox
                  loadingComponent={
                    <div className="d-flex align-items-center justify-content-center h-100">
                      Loading conversations...
                    </div>
                  }
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <br/><br/>
      <style>
        {`
          .chat-container {
            position: relative;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }

          /* Ensure TalkJS container fills available space */
          .chat-container > div {
            height: 100% !important;
          }

          @media (max-width: 768px) {
            .chat-container {
              border: none;
              border-radius: 0 !important;
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default ChatPage;